import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
import moment from 'moment';
import classnames from 'classnames/bind';
import styles from '../styles.scss';
import ListingBadge, { BADGE_MODE } from './base';
import { isREO } from './utils';
const cx = classnames.bind(styles);
const elmId = 'open_house_badge';
export default class OpenHouseScheduledBadge extends ListingBadge {
    static title = 'Open House';
    static titleIcon = 'sign-in-alt';
    static shouldBeIncluded(listing, badgeMode) {
        if (badgeMode === BADGE_MODE.CONDENSED)
            return false;
        const openHouseSchedules = listing.open_houses || [];
        return (Boolean(openHouseSchedules.length) &&
            openHouseSchedules[0].date &&
            isREO(listing));
    }
    get content() {
        const openHouseSchedules = _.get(this.props.listing, 'open_houses', []);
        return (_jsxs("div", { children: ["Tour this property on:", openHouseSchedules.map((schedule, i) => (_jsxs("span", { className: cx('u-display-f', 'u-display-f-between'), children: [_jsx("strong", { "data-elm-id": `${elmId}_date_${i}`, children: moment(schedule.date, 'YYYY-MM-DD').format('MM/DD/YY') }), ' ', _jsxs("span", { "data-elm-id": `${elmId}_time_${i}`, children: [schedule.start_time, " to ", schedule.end_time] })] }, i)))] }));
    }
}
//# sourceMappingURL=openHouse.js.map